import useSoftpullModalEvents from '~/hooks/flp/useSoftpullModalEvents';
import ErrorBoundary from '~/utilities/ErrorBoundary';
import CustomizeYourDeal from './CustomizeYourDeal';
import Hero from './Hero';
import PrequalFaq from './PrequalFAQ';
import PrequalErrorBoundary from './PrequalPageError';
import ShopStyles from './ShopStyles';
import ShopTerms from './ShopTerms';
import PageViewAnalytics from '../PageViewAnalytics';

export default function PrequalifiedContent() {
  useSoftpullModalEvents();

  return (
    <ErrorBoundary
      FallbackComponent={PrequalErrorBoundary}
      section="Prequalified Content"
    >
      <PageViewAnalytics page="prequalified" />
      <Hero />
      <CustomizeYourDeal />
      <ShopStyles />
      <ShopTerms />
      <PrequalFaq />
    </ErrorBoundary>
  );
}
